import { A as r, c as C, C as T, b as A, a as c, F as i, P as p } from "./api-DwyZ-w1t.js";
const n = {
  EPCS_ORDER_SIGNING: "epcs-order-signing",
  CLINICAL_APP_LOGIN: "clinical-app-login",
  SUPERVISED_ASSURANCE: "supervised-assurance",
  ENROLL_LOGIN: "enroll-login",
  DESKTOP_ACCESS: "endpoint-login",
  IDP_AUTHN: "idp-authn"
}, s = { ENDPOINT: "endpoint", AUTHN_WEB_UI: "authn-web-ui" };
var o = /* @__PURE__ */ ((a) => (a.FACTOR_DATA_READY = "factor-data-ready", a.FACTOR_CHANGED = "factor-changed", a.ERROR = "error", a.CLOSE_WINDOW = "close-window", a.APP_AUTHENTICATION_STATUS = "app-authentication-status", a.APP_AUTHENTICATION_CANCELED = "app-authentication-canceled", a))(o || {});
export {
  o as AgentEvent,
  r as AuthnMethod,
  C as ConsentActionType,
  T as ConsentGrantType,
  A as ConsentType,
  n as ContextType,
  c as FACTORS,
  i as FactorCategory,
  p as PushStatus,
  s as ResourceType
};
//# sourceMappingURL=types.js.map
